import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=26f54432&scoped=true&"
import script from "./page2.vue?vue&type=script&lang=js&"
export * from "./page2.vue?vue&type=script&lang=js&"
import style0 from "./page2.vue?vue&type=style&index=0&id=26f54432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f54432",
  null
  
)

export default component.exports